import React, { useState } from 'react'

//Material UI
import {
  Grid,
  Button,
  Dialog,
  Select,
  MenuItem,
  TextField,
  Accordion,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  AccordionDetails,
  AccordionSummary
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { videoTypes } from '../../Constants/videoTypes'

//Styles
import './OnlineVideos.scss'

const OnlineVideos = ({
  videos,
  setOnlineVideos,
  max,
  setErrorLabel,
  marketingDialog = false,
  marketingSetter = null,
  localMarketingSetter = null,
  disableHandleClick = false
}) => {
  const [open, setOpen] = useState(false)
  const [provider, setProvider] = useState(videoTypes.Youtube)

  const [video, setVideo] = useState({
    caption: '',
    fileName: '',
    fileSize: '',
    provider: 0,
    originalName: '',
    type: 'online',
    url: ''
  })

  const handleInputChange = (event) => {
    setVideo({
      ...video,
      originalName: Date.now().toString(),
      [event.target.name]: event.target.value
    })
  }

  const setEmptyVideo = () => {
    setVideo({
      caption: '',
      fileName: '',
      fileSize: '',
      provider: 0,
      originalName: '',
      type: 'online',
      url: ''
    })
  }

  const handleClickOpen = () => {
    if (!disableHandleClick) {
      setOpen(true)
    }
  }
  const handleClose = () => {
    setOpen(false)
    setEmptyVideo()
  }

  const providerSelected = (e) => {
    setProvider(e.target.value)
    setVideo({
      ...video,
      provider: e.target.value
    })
  }

  const getProviderName = (prov) => {
    switch (prov) {
      case 0:
        return 'youtube'
      case 1:
        return 'vimeo'
      case 2:
        return 'facebook'
      case 3:
        return 'dailymotion'
      default:
        return ''
    }
  }

  const addVideoProcess = (provider, url, video, match, filter = filterDefault) => {
    if (video.url.match(match)) {
      const filtered = filter(video.url)
      video.url = filtered
      if (marketingDialog) {
        marketingSetter((prevState) => ({
          ...prevState,
          onlineVideos: [...videos, video]
        }))
      } else {
        setOnlineVideos([...videos, video])
      }

      setOpen(false)
      setProvider(provider)
      setEmptyVideo()
    } else {
      if (marketingDialog) {
        localMarketingSetter((prevState) => ({
          ...prevState,
          errorLabel: `Provide a link from ${url}`
        }))
        setInterval(() => {
          localMarketingSetter((prevState) => ({
            ...prevState,
            errorLabel: ''
          }))
        }, 1000)
      } else {
        setErrorLabel(`Provide a link from ${url}`)
        setInterval(() => {
          setErrorLabel('')
        }, 1000)
      }
    }
  }

  const addVideo = () => {
    if (video.caption !== '' && video.url !== '') {
      if (video && video.provider === 0) {
        const youtubeMatch =
          /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
        addVideoProcess(0, 'youtube', video, youtubeMatch, filterYoutube)
      }
      if (video && video.provider === 1) {
        const vimeoMatch =
          /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/
        addVideoProcess(0, 'vimeo', video, vimeoMatch, filterVimeo)
      }
      if (video && video.provider === 2) {
        const facebookMatch =
          /^https?:\/\/www\.facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/
        addVideoProcess(0, 'facebook', video, facebookMatch, filterFB)
      }
      if (video && video.provider === 3) {
        const dailyMotionMatch =
          /(?:dailymotion\.com(?:\/video|\/hub)|dai\.ly)\/([0-9a-z]+)(?:[-_0-9a-zA-Z]+#video=([a-z0-9]+))?/g
        addVideoProcess(0, 'dailymotion', video, dailyMotionMatch, filterDaily)
      }
    } else {
      if (marketingDialog) {
        localMarketingSetter((prevState) => ({
          ...prevState,
          errorLabel: 'Provide the complete information'
        }))
        setInterval(() => {
          localMarketingSetter((prevState) => ({
            ...prevState,
            errorLabel: ''
          }))
        }, 1000)
      } else {
        setErrorLabel('Provide the complete information')
        setInterval(() => {
          setErrorLabel('')
        }, 1000)
      }
    }
  }

  const filterDefault = (url) => {
    return url
  }

  const filterYoutube = (url) => {
    const regex = /^https?:\/\/www\.youtube\.com\/watch\?v=/
    if (url.match(regex)) {
      const justid = url.replace(regex, '')
      return `https://www.youtube.com/embed/${justid}`
    }
    return url
  }

  const filterFB = (url) => {
    const regexFB = /^https?:\/\/www\.facebook\.com\/[A-Za-z/]*/
    if (url.match(regexFB)) {
      const justid = url.replace(regexFB, '')
      return `https://www.facebook.com/video/embed?video_id=${justid}`
    }
    return url
  }

  const filterVimeo = (url) => {
    const regex = /^https?:\/\/vimeo\.com\//
    if (url.match(regex)) {
      const justid = url.replace(regex, '')
      return `https://player.vimeo.com/video/${justid}`
    }
    return url
  }

  const filterDaily = (url) => {
    const regex = /^https?:\/\/www\.dailymotion\.com\/video\//
    if (url.match(regex)) {
      const justid = url.replace(regex, '')
      return `https://www.dailymotion.com/embed/video/${justid}`
    }
    return url
  }

  return (
    <>
      <h3>Online videos</h3>
      <Button
        variant="outlined"
        color="primary"
        className="button form-control"
        size="medium"
        onClick={handleClickOpen}
        style={{ maxWidth: '280px', minWidth: '280px' }}
      >
        Add online video
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        className="online-dialog"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="online-dialog-title">
          <span>Add online video</span>
          <IconButton aria-label="close" className="close-button" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="online-dialog-content">
          <Grid container>
            <form noValidate autoComplete="off">
              <Grid size={12}>
                <label htmlFor="status">Provider</label>
                <br />
                <Select
                  id="status"
                  variant="outlined"
                  className="provider-field"
                  defaultValue={videoTypes.Youtube}
                  onChange={providerSelected}
                >
                  <MenuItem value={videoTypes.Youtube}>Youtube</MenuItem>
                  <MenuItem value={videoTypes.Vimeo}>Vimeo</MenuItem>
                  <MenuItem value={videoTypes.Facebook}>Facebook</MenuItem>
                  <MenuItem value={videoTypes.Dailymotion}>Dailymotion</MenuItem>
                </Select>
              </Grid>
              <Grid size={12}>
                {provider === 0 ? (
                  <Accordion elevation={0}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className="online-summary"
                    >
                      <h4 className="instructions-title" style={{ margin: 0 }}>
                        Instructions to know how to demonetize your video
                      </h4>
                    </AccordionSummary>
                    <AccordionDetails>
                      <ul>
                        <li>Sign in to YouTube.</li>
                        <li>
                          Click your profile picture {'>'}{' '}
                          <span className="highlight">YouTube Studio</span>.
                        </li>
                        <li>
                          In the left menu, click <span className="highlight">Content</span>.
                        </li>
                        <li>Select the video you want to turn off ads for.</li>
                        <li>
                          In the left menu, click <span className="highlight">Monetization</span>.
                        </li>
                        <li>
                          In the top “Monetization” box, click {'>'}{' '}
                          <span className="highlight">Off</span> {'>'}{' '}
                          <span className="highlight">Apply</span>.
                        </li>
                        <li>
                          In the top right, click <span className="highlight">Save</span>.
                        </li>
                      </ul>
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  <></>
                )}
              </Grid>
              <Grid size={12}>
                <Grid container className="title-container">
                  <label className="label-messagge">
                    *Add a valid url from <span className="valid">{getProviderName(provider)}</span>
                  </label>
                </Grid>
              </Grid>
              <Grid size={12}>
                <Grid container className="title-container">
                  <label htmlFor="caption" className="label-container label-online">
                    Caption
                  </label>
                  <Grid size={12} className="container-field">
                    <TextField
                      id="caption"
                      name="caption"
                      variant="outlined"
                      className="online-textfield"
                      inputProps={{ maxLength: 40 }}
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={12}>
                <Grid container className="title-container">
                  <label htmlFor="url" className="label-container label-online">
                    Link URL
                  </label>
                  <Grid size={12} className="container-field">
                    <TextField
                      id="url"
                      name="url"
                      variant="outlined"
                      className="online-textfield"
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </DialogContent>
        <DialogActions>
          <div className="buttons-container">
            <Button
              onClick={addVideo}
              className="save-button"
              variant="contained"
              color="primary"
              size="medium"
            >
              Add video
            </Button>
            <Button
              onClick={handleClose}
              color="primary"
              autoFocus
              variant="outlined"
              className="button form-control"
              size="medium"
            >
              Cancel
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default OnlineVideos
